import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CommonGrid from '../../CommonGrid';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import "../../../../assets/css/custom-ag-grid.css";
import WorkflowSessionModal from '../../../ItemProperties/WorkflowSessionModal';
import Split from "react-split";
import { styled } from '@mui/system';
import { Drawer, Button } from "@mui/material";
import ErrorModal from '../../../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from '@mui/icons-material/Close';

const drawerWidth = '450px'
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create(["margin", "padding"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        margin: 0,
        marginLeft: 0, // Initially no margin
        padding: 0,
        ...(open && {
            transition: theme.transitions.create(["marginLeft", "padding"], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            //    marginLeft: drawerWidth, Set marginLeft to drawerWidth when open
        }),
    })
);

export const CustomHeaders = ({ setOpenModal, openModal, customHeaders, setCustomHeaders, handleCancel, handleDone }) => {
    const { t } = useTranslation();
    const [deletedKeys, setDeletedKeys] = useState([]);
    const [isApplyButtonEnabled, setIsApplyButtonEnabled] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [currentRow, setCurrentRow] = useState('');
    const [workflowSessionModal, setWorkflowSessionModal] = useState({ open: false, isFirstTime: false });
    const [keyValue, setKeyValue] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [gridApi, setGridApi] = useState(null);

    const isEditable = (params) => {
        return params.data.key;
    };

    const handler = () => {
        const updated = [];
        gridApi?.forEachNode((node) => {
            const key = node?.data?.key;
            const value = node?.data?.value;
            key !== '' && value !== '' && updated.push({ key, value })
        });
        const afterDelete = reStructure(updated, true);
        handleDone(afterDelete)
    }

    const gridOptions = {
        columnDefs: [
            {
                showDeleteIconOnly: true,
                isDeleteControl: true,
                editable: false,
                deleteHandler: (data) => {
                    setIsApplyButtonEnabled(true);
                    if (data?.initalData) {
                        setDeletedKeys(prev => [...prev, data]);
                    }
                },
                showDeleteIcon: (data) => {
                    return data.key || data.value;
                },
                headerClass: "first-column-header",
            },
            {
                headerName: t("LBL_KEY"),
                field: "key",
                editable: true,
                resizable: false,
                preventTabAndEnter: true,
            },
            {
                headerName: t("LBL_FIELD_VALUE"),
                field: "value",
                editable: isEditable,
                resizable: false,
            },
            {
                showDeleteIconOnly: true,
                cellRenderer: (info) => CustomCellRenderer(info),
                editable: isEditable,
            },
        ],
    };

    const handleBackdropClick = (event, reason) => {
        if (reason === "backdropClick") return;
    };

    const getCurrentRow = (data) => {
        setCurrentRow(data);
    }

    const getGridAPI = (api) => {
        setGridApi(api);
    }

    const CustomCellRenderer = (info) => {
        const { data } = info;
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    size="small"
                    disableElevation
                    disabled={!data?.key}
                    onClick={() => {
                        getCurrentRow(data);
                        setWorkflowSessionModal({ open: true, isFirstTime: true });
                    }}
                >
                    <MoreHorizIcon fontSize="small" />
                </Button>
            </div>
        );
    };

    const reStructure = (rows, isReturn) => {
        let res = '';
        const tempKeyValues = [];
        rows?.forEach((row) => {
            tempKeyValues.push(`${row?.key}\u001f${row?.value}`);
        });
        if (tempKeyValues?.length) {
            res = tempKeyValues.join('\u001e');
        }
        setCustomHeaders(res.length > 0 ? res + '\u001e' : '');
        if (isReturn) return res.length > 0 ? res + '\u001e' : '';
    }

    const deStructureHeadersData = () => {
        const rows = [];
        if (customHeaders) {
            // Split the data into key-value pairs using record separator (\u001e)
            const keyValuePairs = customHeaders?.split("\u001e");

            // Process each key-value pair
            keyValuePairs.forEach((keyValue, index) => {
                // Split each key-value pair using unit separator (\u001f)
                const [key, value] = keyValue.split("\u001f");

                // Ensure there are at least two parts (key and value)
                if (key && value) {
                    // Process the key and value as needed
                    rows.push({ id: index + 1, key: key, value: value });
                }
            });
            rows?.push({ id: rows.length + 1, key: '', value: '' });
        } else {
            rows.push({ id: 1, key: '', value: '' });
        }
        setRowData(rows);
    }

    const checkDuplicateKey = (id, value, gridApi) => {
        if (!value) return false;
        let duplicateFound = false;
        gridApi.forEachNode((node) => {
            if (node.data.id !== id && node.data.key === value) duplicateFound = true;
        });
        return duplicateFound;
    };

    const checkEmptyKey = (data, oldValue) => {
        if ((data.inititlaData && !data.key) || (!data.key && data.value)) return { isEmptyKey: true, valueToKeep: oldValue }
        return { isEmptyKey: false }
    }

    const updateRowData = (updatedHeaders) => {
        setRowData(updatedHeaders);
        reStructure(updatedHeaders);
    }

    const setFinalValue = (value) => {
        setKeyValue(value);
        const updatedHeaders = rowData?.map((row) =>
            currentRow?.id === row?.id ? { ...row, value: value } : row
        );
        updateRowData(updatedHeaders)
    };

    const handleCellValueChanged = (gridOptions) => {
        const data = gridOptions?.data;
        const { value, key, id } = data;
        if (gridOptions.newValue !== gridOptions.oldValue) setIsApplyButtonEnabled(true);
        const colId = gridOptions.column.colId;
        if (colId === "key") {
            const id = gridOptions.data.id;
            const newValue = gridOptions.data.key;
            const rowIndex = gridOptions.rowIndex;
            const isDuplicateKey = checkDuplicateKey(id, newValue, gridOptions.api);
            const { isEmptyKey, valueToKeep } = checkEmptyKey(gridOptions.data, gridOptions.oldValue);
            if (isDuplicateKey) {
                var rowNode = gridOptions.api.getDisplayedRowAtIndex(rowIndex);
                setErrorModal(true);
                setErrorMessage(t("BOX_NAME_ALREADY_EXISTS"));
                rowNode.setDataValue(colId, gridOptions?.oldValue || "");
            }
            else if (isEmptyKey) {
                var rowNode = gridOptions.api.getDisplayedRowAtIndex(rowIndex);
                setErrorModal(true);
                setErrorMessage(t("BOX_ENTER_NEW_NM_FOR_KEY"));
                if (valueToKeep) rowNode.setDataValue(colId, valueToKeep);
            } else {
                const updatedHeaders = rowData?.map((row) => id === row?.id ? { ...row, key: key, value: value } : row);
                if (key && id === updatedHeaders.length) updatedHeaders?.push({ id: updatedHeaders?.length + 1, key: '', value: '' })
                updateRowData(updatedHeaders)
            }
        }
    };

    useEffect(() => {
        if (openModal) {
            deStructureHeadersData();
        }
    }, [openModal])

    return <>
        <Drawer
            anchor="left"
            open={openModal}
            // onClose={handleCancelClick}
            ModalProps={{
                onBackdropClick: handleBackdropClick,
            }}
            sx={{
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                    width: "100%",
                    boxSizing: "border-box",
                    background: "transparent",
                },
            }}>
            <Main open={openModal || workflowSessionModal.open}>
                <Split
                    className="split height-100 flex"
                    direction="horizontal"
                    gutterSize={4}
                    snapOffset={0}
                    dragInterval={4}
                    minSize={[550, 0]}
                    sizes={[67, 33]}
                >
                    {[
                        <div className="flex-column height-100" key="main" style={{ backgroundColor: "#fff", position: "relative" }}>
                            <div className="quick-add-container" key={0}>
                                <div style={{ lineHeight: "25px" }}>
                                    <p style={{ marginBottom: "10px" }}>
                                        {t("DIAG_MQ_CUSTOM_HEADER_FIELDS_TIT")}
                                    </p>
                                    <div className="font-12">
                                        <p>{t("DIAG_MQ_CUSTOM_HEADER_FIELDS_DESC")}</p>
                                    </div>
                                </div>
                                <Button size='small' style={{ background: 'white' }} onClick={() => {
                                    handleCancel()
                                }}><CloseIcon fontSize='large' /></Button>
                            </div>
                            <div className="quick-add-right-container" key={1}>
                                <CommonGrid
                                    rowData={rowData}
                                    gridOptions={gridOptions}
                                    getGridAPI={getGridAPI}
                                    gridProps={{
                                        onCellValueChanged: handleCellValueChanged
                                    }}
                                    containerClasses={'account-data-grid-container'}
                                />
                            </div>
                            <div className="flex-column height-100" style={{ backgroundColor: "#fff", position: "relative" }} key={2}>
                                <div className="margin-top-16 margin-left-16">
                                    <Button size='small' className="margin-left-4" variant="outlined" color="primary" onClick={handler}>
                                        {t("BTN_DONE")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ]}
                </Split>
            </Main>
        </Drawer>
        <ErrorModal
            errorModal={errorModal}
            errorMessage={errorMessage}
            handleErrorModal={setErrorModal}
        />
        <WorkflowSessionModal
            valueLabel={currentRow?.key || t("LBL_FIELD_VALUE")}
            showAccountData={true}
            showCallingWorkflow={true}
            showSystemData={true}
            showWorkflowSession={true}
            showDateAndTime={true}
            openModal={workflowSessionModal}
            setModalOpen={setWorkflowSessionModal}
            handleClose={() => setWorkflowSessionModal({ open: false, isFirstTime: false })}
            initialValue={currentRow?.value || ''}
            valuesHandler={(value) => {
                setFinalValue(value);
            }}
        />
    </>
}

export default CustomHeaders